export default class LocalStorageHelper {
    public static emailForSignIn(): string | null {
        return localStorage.getItem('email-for-sign-in')
    }

    public static setEmailForSignIn(email: string) {
        localStorage.setItem('email-for-sign-in', email)
    }
}
